import { render, staticRenderFns } from "./NoMoreCoinsCard.vue?vue&type=template&id=cdb18f54&"
import script from "./NoMoreCoinsCard.vue?vue&type=script&lang=js&"
export * from "./NoMoreCoinsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports